import { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { buildGreeting } from './greeting';
import { useAssistantConfig } from './hooks/useAssistantConfig';
import { useLauncherLabel } from './hooks/useLauncherLabel';
import { useSupportAssistantSuppressed } from './assistantVisibility';
import SupportAssistantBubble from './SupportAssistantBubble';
import SupportAssistantWindow from './SupportAssistantWindow';
import type { AssistantMessage } from './SupportAssistantWindow';

interface AuthState {
  auth: {
    user?: {
      id?: number;
      firstName?: string;
      lastName?: string;
      name?: string;
    };
  };
}

const SupportAssistant = () => {
  const user = useSelector((state: AuthState) => state.auth.user);
  const firstName = user?.firstName || user?.name?.split(' ')[0] || null;

  const greeting = useMemo(() => buildGreeting(firstName), [firstName]);

  const { config, loading } = useAssistantConfig();
  const suppressed = useSupportAssistantSuppressed();
  const { showLabel, markSeen } = useLauncherLabel(user?.id);

  const [state, setState] = useState<'bubble' | 'open' | 'hidden'>('bubble');
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  const [messages, setMessages] = useState<AssistantMessage[]>([
    { role: 'assistant', content: greeting },
  ]);

  const openAssistant = useCallback(() => {
    setState('open');
    setHasBeenOpened(true);
    markSeen();
  }, [markSeen]);
  const dismissBubble = useCallback(() => setState('hidden'), []);
  const closeAssistant = useCallback(() => setState('bubble'), []);

  if (loading || !config?.assistantEnabled || suppressed) return null;
  if (state === 'hidden') return null;

  return (
    <div className="th" style={{ overflow: 'visible' }}>
      {state === 'bubble' && (
        <SupportAssistantBubble
          onClick={openAssistant}
          onDismiss={dismissBubble}
          showLabel={showLabel}
        />
      )}

      {hasBeenOpened && (
        <div style={{ display: state === 'open' ? undefined : 'none' }}>
          <SupportAssistantWindow
            onClose={closeAssistant}
            firstName={firstName}
            messages={messages}
            setMessages={setMessages}
          />
        </div>
      )}
    </div>
  );
};

export default SupportAssistant;